module.exports = __webpack_public_path__ + "img/ThinkingAnimate.ae2e7bfe.gif";